import React from 'react';
import { softwareBacklogConfigProviderEntrypoint } from '@jira/ai-rovo_actions-software-backlog/src/softwareBacklogConfigProviderEntrypoint.tsx';
import { softwareVersionDetailConfigProviderEntrypoint } from '@jira/ai-rovo_actions-software-version-detail/src/softwareVersionDetailConfigProviderEntrypoint.tsx';
import { projectVersionsConfigProviderEntrypoint } from '@jira/ai-rovo_actions-project-versions/src/projectVersionsConfigProviderEntrypoint.tsx';
import { issueConfigProviderEntrypoint } from '@jira/ai-rovo_actions-issue/src/issueConfigProviderEntrypoint.tsx';
import { planTimelineConfigProviderEntrypoint } from '@jira/ai-rovo_actions-plan-timeline/src/planTimelineConfigProviderEntrypoint.tsx';
import type { RouteName } from '@atlassian/jira-route-name-types/src/RouteName.tsx';
import { AiRovoIssueViewNudgesProvider } from './AiRovoIssueViewNudgesProvider.tsx';
import { AiRovoSoftwareBacklogNudgesProvider } from './AiRovoSoftwareBacklogNudgesProvider.tsx';

/**
 * Add new entrypoints here to the type and to the jiraRouteToConfigProvider object
 */
export type RovoEntryPointComponent =
	| typeof softwareBacklogConfigProviderEntrypoint
	| typeof softwareVersionDetailConfigProviderEntrypoint
	| typeof projectVersionsConfigProviderEntrypoint
	| typeof issueConfigProviderEntrypoint
	| typeof planTimelineConfigProviderEntrypoint;

export const jiraRouteToConfigProvider: Partial<
	Record<
		RouteName,
		{
			entrypoint: RovoEntryPointComponent;
			nudges?: () => React.JSX.Element;
		}
	>
> = {
	'software-backlog': {
		entrypoint: softwareBacklogConfigProviderEntrypoint,
		nudges: () => <AiRovoSoftwareBacklogNudgesProvider />,
	},
	'software-version-detail': {
		entrypoint: softwareVersionDetailConfigProviderEntrypoint,
	},
	'project-versions': {
		entrypoint: projectVersionsConfigProviderEntrypoint,
	},
	issue: {
		entrypoint: issueConfigProviderEntrypoint,
		nudges: () => <AiRovoIssueViewNudgesProvider />,
	},
	'software-plan-timeline': {
		entrypoint: planTimelineConfigProviderEntrypoint,
	},
};
